type VisitedSealProps = {
  note: string;
};

export function VisitedSeal({ note }: VisitedSealProps) {
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-coral-100 bg-coral-50 px-4 py-3.5">
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-coral-500 text-white shadow-[0_4px_12px_rgba(233,113,82,0.3)]">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden>
          <path
            d="M9 1.5L11.3 6.2L16.5 7L12.7 10.7L13.6 16L9 13.5L4.4 16L5.3 10.7L1.5 7L6.7 6.2L9 1.5Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <div className="min-w-0 flex-1 pt-0.5">
        <div className="mb-1 flex flex-nowrap items-center gap-1.5">
          <span className="text-[13.5px] font-bold tracking-tight text-coral-900">
            我们实地探访过
          </span>
          <span className="shrink-0 rounded-pill bg-coral-700 px-1.5 py-0.5 text-[10px] font-bold tracking-wide text-white">
            VERIFIED
          </span>
        </div>
        <p className="text-flow text-[12.5px] leading-relaxed text-ink-700">{note}</p>
      </div>
    </div>
  );
}
